"use strict";
var Observable_1 = require('../../Observable');
var repeatWhen_1 = require('../../operator/repeatWhen');
Observable_1.Observable.prototype.repeatWhen = repeatWhen_1.repeatWhen;
//# sourceMappingURL=repeatWhen.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/rxjs/add/operator/repeatWhen.js
// module id = ../../../../rxjs/add/operator/repeatWhen.js
// module chunks = 3